import { useEffect, useMemo, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
//
import { Col, Row } from "react-bootstrap";
import { LuListMinus } from "react-icons/lu";
import { PiHandCoinsFill } from "react-icons/pi";
import { useNavigate, useParams } from "react-router-dom";
import Table from "../../Components/Table/Table.js";
import ToolTip from "../../Components/ToolTip.js";
import ThemeSpinner from "../../Components/general/ThemeSpinner.jsx";
import ThemeSelect from "../../Components/input/ThemeSelect.jsx";
import { useGetGameStatsByGameSlugQuery } from "../../store/apis/gameApi.js";
import { GAME_STATS_TYPE_ENUM } from "../../utils/app-constants.js";
import { useForm } from "react-hook-form";
import moment from "moment";
import { BackButton, SubTitle } from "../../Components/index.js";

const GameStatsScreen = ({ setPage }) => {
    const params = useParams()
    const navigate = useNavigate()

    const SELECT_OPTIONS = Object.values(GAME_STATS_TYPE_ENUM)?.map(item => ({ label: item, value: item }))

    const {
        control,
        watch,
        formState: { errors }
    } = useForm({
        defaultValues: {
            type: { label: GAME_STATS_TYPE_ENUM.WEEKLY, value: GAME_STATS_TYPE_ENUM.WEEKLY }
        }
    })
    const type = watch('type')

    const [indicationMessage, setIndicationMessage] = useState("loading...");

    const [apiData, setApiData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);

    const [searchQuery, setSearchQuery] = useState("");

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const { data, isSuccess, isFetching: isLoading, refetch } =
        useGetGameStatsByGameSlugQuery({
            slug: params.slug,
            params: {
                type: type?.value || type,
                page: currentPage,
                limit: pageSize
            }
        }, { refetchOnMountOrArgChange: true });

    const handleTableChange = (type, { page, sizePerPage }) => {
        setCurrentPage(page);
        setPageSize(sizePerPage);
    };


    useEffect(() => {
        if (isSuccess && data?.data) {
            setApiData(data.data); // Save raw API data
            setFilteredData(data.data); // Initially same as raw

            console.log(data.pagination.total_records)

            if (data.data.length === 0) {
                setIndicationMessage("Data not available");
            }
        }
    }, [data, isSuccess]);



    function indication() {
        return indicationMessage;
    }

    const columns = useMemo(() => {
        return [
            {
                dataField: "game.name",
                text: "Game",
                sort: true,
                headerStyle: {
                    // width: "150px",
                },
            },

            {
                dataField: "date",
                text: "Date",
                sort: true,
                headerAlign: "center",
                align: "center",
                headerStyle: {
                    width: "150px",
                },
                formatter: (cellContent, row) => {
                    const value = type?.value || type;
                    return (
                        <p>{value === GAME_STATS_TYPE_ENUM.WEEKLY ? moment(row.date).format('[Week] W, MMM YYYY')
                            : value === GAME_STATS_TYPE_ENUM.MONTHLY ? moment(row.date).format('MMMM YYYY') : moment(row.date).format('MMM DD, YYYY')}</p>
                    );
                },
            },
            {
                dataField: "coins_won",
                text: "Coins Won",
                sort: true,
                headerAlign: "center",
                align: "center",
                headerStyle: {
                    width: "150px",
                },
                formatter: (cellContent, row) => {
                    return (
                        <p>{row.coins_won}</p>
                    );
                },
            },
            {
                dataField: "coins_loss",
                text: "Coins Loss",
                sort: true,
                headerAlign: "center",
                align: "center",
                headerStyle: {
                    width: "150px",
                },
                formatter: (cellContent, row) => {
                    return (
                        <p>{row.coins_loss}</p>
                    );
                },
            },
            {
                dataField: "tickets_won",
                text: "Tickets Won",
                sort: true,
                headerAlign: "center",
                align: "center",
                headerStyle: {
                    width: "150px",
                },
                formatter: (cellContent, row) => {
                    return (
                        <p>{row.tickets_won}</p>
                    );
                },
            },
            {
                dataField: "tickets_loss",
                text: "Tickets Loss",
                sort: true,
                headerAlign: "center",
                align: "center",
                headerStyle: {
                    width: "150px",
                },
                formatter: (cellContent, row) => {
                    return (
                        <p>{row.tickets_loss}</p>
                    );
                },
            },
            // {
            //     dataField: "actions",
            //     text: "Actions",
            //     headerAlign: "center",
            //     align: "center",
            //     headerStyle: {
            //         width: "200px",
            //     },
            //     formatter: (cellContent, row) => {
            //         // console.log(row)
            //         if (row.slug) {
            //             return (
            //                 <div className="d-flex justify-content-center align-items-center ">
            //                     <ToolTip placement={"top"} content={"Send Coins"}>
            //                         <div
            //                             className="d-flex justify-content-center align-items-center bg-red-hover rounded-3 p-2 mx-2"
            //                             role="button"
            //                         >
            //                             <span className={`d-flex align-items-center pe-1`}>
            //                                 <PiHandCoinsFill size={22} />
            //                             </span>
            //                         </div>
            //                     </ToolTip>
            //                     {!row.sub_game_count ? <></> :
            //                         <ToolTip placement={"top"} content={"View Games"}>
            //                             <div
            //                                 className="d-flex justify-content-center align-items-center bg-red-hover rounded-3 p-2 mx-2"
            //                                 role="button"
            //                                 onClick={() => navigate(`/admin/game/${row.slug}/stats`)}
            //                             >
            //                                 <span className={`d-flex align-items-center pe-1`}>
            //                                     <LuListMinus size={22} />
            //                                 </span>
            //                             </div>
            //                         </ToolTip>
            //                     }
            //                 </div>
            //             );
            //         }
            //     },
            // },
        ]
    }, [type]);

    return (
        <div className="MainContainer">
            <div className="headerContainer">
                <Row className="w-100 align-items-center">
                    <Col md={6}>
                        <div className="d-flex flex-row align-items-center gap-3 text-white">
                            <BackButton isRelative={true} />
                            <SubTitle text={params.slug.replace('-', ' ')} classes="text-capitalize" />
                        </div>
                    </Col>

                    <Col md={6}>
                        <ThemeSelect
                            name="type"
                            control={control}
                            errors={errors}
                            placeholder="Select Type"
                            options={SELECT_OPTIONS}
                        />
                    </Col>
                </Row>
            </div>

            <div className="mainTable">
                {isLoading ? (
                    <ThemeSpinner />
                ) : (
                    <Table
                        // classes={`${dataFetched && isFetching ? "blur-table" : ""}`}
                        key={type}
                        data={filteredData || []}
                        columns={columns}
                        indication={indication}
                        isRemotePagination={true}
                        totalRecords={data?.pagination?.total_records || 0}
                        currentPage={currentPage}
                        pageSize={pageSize}
                        refetch={handleTableChange}
                    />
                )}
            </div>
        </div>
    );
};

export default GameStatsScreen;
